import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Card, Popover, Badge } from "antd";
import { idConvocatorias } from "../../../../redux/actions/convocatoriaAction";
import { Convocatoria2 } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import "./cards.style.scss";
import moment, { now } from "moment";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { ReactComponent as CalendarIcon } from "../../../../assets/calendar-detail.svg";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import ImageNotFound from "../../../../assets/enmascarar-detail.png";
import { textDecorationLine } from "html2canvas/dist/types/css/property-descriptors/text-decoration-line";
import { FaMapMarkerAlt  } from "react-icons/fa";
import { ModalVisualizarEvento } from "../../VerConvocatorias/components/Avisos/ModalVisualizarEvento";

interface StateConvocatoria {
  convocatorias: Convocatoria2;
}

export const CardsEvents: React.FC<StateConvocatoria> = (
  props: StateConvocatoria
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [dataImg, setDataImg] = useState<any>();
  const [visualizarEvento, setVisualizarEvento] = useState<boolean>(false);

  const mostrarModalPortafolio = () => {
    setVisualizarEvento(true);
  }
  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        setLoading(false)
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  const calcularEstado = () => {
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2, '0');
    var day = String(today.getDate()).padStart(2, '0');
    var hours = String(today.getHours()).padStart(2, '0');
    var minutes = String(today.getMinutes()).padStart(2, '0');
    var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    var estado = 'Cerrada'; // Por defecto, considerar que está cerrada hasta que se demuestre lo contrario
    var inicio = props.convocatorias.fechas.filter((data) => data.clave === "Apertura")[0].valormin
    var cierre = props.convocatorias.fechas.find((data) => data.clave === "Cierre");
    if (cierre) {
        var valormax = new Date(cierre.valormax)
        valormax.setHours(valormax.getHours() - 1) // Resta una hora
        var year2 = valormax.getFullYear()
        var month2 = String(valormax.getMonth() + 1).padStart(2, '0')
        var day2 = String(valormax.getDate()).padStart(2, '0')
        var hours2 = String(valormax.getHours()).padStart(2, '0')
        var minutes2 = String(valormax.getMinutes()).padStart(2, '0')
        var formattedDate2 = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`
      }

    if (inicio && cierre) {
      if (formattedDate >= inicio && formattedDate <= formattedDate2) {
        estado = 'Abierta'
      }
      else if(formattedDate <= inicio) {
        estado = 'En espera'
      }
      else {
        estado = 'Cerrada'
      }
      return estado
    }
  }


  useEffect(() => {
    getLineasConvocatorias();
  }, [])

  useEffect(() => {
    getImageConvocatoria();
  }, [props.convocatorias]);

  getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)

  return (
    <>
      <a
        rel="noopener noreferrer"
        onClick={(e) => {
          mostrarModalPortafolio()
          dispatch(idConvocatorias(props.convocatorias.idconvocatorias)); // Lógica adicional
        }}
        style={{textDecoration: "none"}}
      >
        <Card
            hoverable
            className="card-template-convocatoria-info"
            style={{ width: '100%', minHeight: '220px' }}
            loading={loading}
          >
            <div className="row">
              {/* Columna de la imagen */}
              <div className="col-md-5">
                <img
                  alt="example"
                  className="card-image-detail-convocatoria"
                  style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                  src={dataImg ? dataImg : ImageNotFound}
                />
              </div>

              {/* Columna de la información */}
              <div className="col-md-7 px-3 d-flex flex-column justify-content-between">
                <div>
                  <div className="container-detalle-semibold font-weight-600 mb-3" style={{ fontSize: '20px' }}>
                    {
                      props.convocatorias.nombre_convocatoria
                    }
                  </div>

                  {/* Fechas */}
                  <div className="row mb-3">
                    <div className="col-2 d-flex align-items-center">
                      <CalendarIcon style={{ fontSize: '40px' }} />
                    </div>
                    <div className="col">
                      <strong style={{ fontSize: '18px' }}>Fecha:</strong><br />
                      <span style={{ fontSize: '18px' }}>
                        {props.convocatorias.fechas?.find(f => f.clave === "Apertura")?.valormin
                          ? moment(props.convocatorias.fechas.find(f => f.clave === "Apertura")!.valormin.substring(0, 10)).format('DD MMM / YYYY')
                          : 'No disponible'}
                      </span>
                    </div>
                  </div>

                  {/* Información adicional */}
                  <div style={{ fontSize: '18px' }}>
                    <div><strong>Área:&nbsp;</strong>
                      {props.convocatorias.area?.map((a: any, i: number) =>
                        i === props.convocatorias.area.length - 1
                          ? a?.text
                          : `${a?.text}, `
                      )}
                    </div>
                    <div>
                      <strong><FaMapMarkerAlt  className="nav-icon" /></strong>
                      {props.convocatorias.objetivo}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
      </a>
      <ModalVisualizarEvento
        visualizar={visualizarEvento}
        setVisualizar={setVisualizarEvento}
        convocatorias={props.convocatorias}
      />
    </>
  );
};
